import * as actionTypes from './actions';

const initialState = {
  update: false,
};

const UpdateGridReducer = (state = initialState, action) => {
  switch (action.type) {
    case actionTypes.UPDATEGRID:
      return {...state, update: action.payload};
    default:
      return state;
  }
};

export default UpdateGridReducer;
